/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ErrorList/view.blocks to change it.
import React from 'react'
import sourcePng from "./source.png"
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function ErrorList({
  children,
  viewPath = "/DesignSystem/Images/ErrorList",
  alignSelf = "auto",
  backgroundColor = "transparent",
  borderBottomLeftRadius = 0,
  borderBottomRightRadius = 0,
  borderTopLeftRadius = 0,
  borderTopRightRadius = 0,
  height = 300,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  marginTop = 0,
  source = sourcePng,
  width = 300
  
}) {
  return (<React.Fragment
>
<img
  data-testid="ErrorList.Image"
  data-view-path={viewPath}
 alt={""}
 src={source}
 style={{'--as-1-Z2jFzaP': alignSelf,'--bc-2-Z2jFzaP': backgroundColor,'--bblr-3-Z2jFzaP': typeof borderBottomLeftRadius === 'number' ? `${borderBottomLeftRadius}px` : borderBottomLeftRadius,'--bbrr-4-Z2jFzaP': typeof borderBottomRightRadius === 'number' ? `${borderBottomRightRadius}px` : borderBottomRightRadius,'--btlr-5-Z2jFzaP': typeof borderTopLeftRadius === 'number' ? `${borderTopLeftRadius}px` : borderTopLeftRadius,'--btrr-6-Z2jFzaP': typeof borderTopRightRadius === 'number' ? `${borderTopRightRadius}px` : borderTopRightRadius,'--h-7-Z2jFzaP': typeof height === 'number' ? `${height}px` : height,'--mb-8-Z2jFzaP': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-9-Z2jFzaP': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-10-Z2jFzaP': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--mt-11-Z2jFzaP': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--w-12-Z2jFzaP': typeof width === 'number' ? `${width}px` : width}}
 className={`views-block ${styles.Image}`}
/>
{children}
</React.Fragment>)
}